import 'babel-polyfill'
import './modernizr-grid'
import { createRoot } from 'react-dom/client'
import App from './App'
import './theme'
import './index.css'

const root = createRoot(document.getElementById('root'))
root.render(<App />)
